"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faFileSlash_1 = require("@fortawesome/pro-regular-svg-icons/faFileSlash");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var Organization = function (_a) {
    var _b;
    var item = _a.item;
    return ((0, jsx_runtime_1.jsx)(PopupText_1.default, { message: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [item.rechVendorId && ((_b = item.rechargedOrganization.excludedVendors) === null || _b === void 0 ? void 0 : _b[item.rechVendorId]) && ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faFileSlash_1.faFileSlash, color: "#F9B9B6", style: { marginRight: 11 } })), item.rechargedOrganization.name] })) }));
};
exports.default = Organization;
